import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom';

function MenuLink({ to, ...props }) {
  if (props.onClick == null && to == null) {
    return (
      <MenuItem
        className="link"
        {...props}
        sx={{ ...props.style, height: '100%' }}
      />
    );
  } else if (props.onClick != null || /^https?:\/\//.test(to)) {
    // The class name here is to avoid a selector precedence issue in a few isolated cases
    return (
      <MenuItem
        className="link"
        component="a"
        href={to}
        {...props}
        sx={{ ...props.style, height: '100%' }}
      />
    );
  } else {
    return (
      <MenuItem
        className="link"
        component={Link}
        to={to}
        {...props}
        sx={{ ...props.style, height: '100%' }}
      />
    );
  }
}

export default MenuLink;
